(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/reducers/player-wager-slice.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/reducers/player-wager-slice.js');
"use strict";

const _RTK = RTK,
  createSlice = _RTK.createSlice,
  createEntityAdapter = _RTK.createEntityAdapter;
const wagerSubscriptionAdapter = createEntityAdapter({
  selectId: _ref => {
    let productId = _ref.productId,
      drawNumber = _ref.drawNumber;
    return "".concat(productId, "_").concat(drawNumber);
  }
});
const playerWagerDrawSubscriptionSlice = createSlice({
  name: 'PlayerWager',
  initialState: wagerSubscriptionAdapter.getInitialState(),
  reducers: {
    addDrawForecastSubscription: wagerSubscriptionAdapter.addOne,
    deleteDrawForecastSubscription: (state, _ref2) => {
      let _ref2$payload = _ref2.payload,
        productId = _ref2$payload.productId,
        drawNumber = _ref2$payload.drawNumber;
      wagerSubscriptionAdapter.removeOne(state, "".concat(productId, "_").concat(drawNumber));
    }
  }
});
setGlobal('svs.components.tipsen.store.reducers.playerWager', {
  slice: playerWagerDrawSubscriptionSlice.reducer,
  actions: playerWagerDrawSubscriptionSlice.actions,
  selectors: wagerSubscriptionAdapter.getSelectors(state => state.PlayerWager.DrawForecastSubscriptions)
});

 })(window);